<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5csrKd/tc-custom/9781454917281.jpg?1712387828723" alt="This image is the cover for the book Chemistry Book, Union Square & Co. Milestones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chemistry Book, Union Square & Co. Milestones
      </h1>
      <p class="bookDescription body article font2">
        <b>An engaging and lushly illustrated guide to the greatest achievements, discoveries, and innovations in the world of chemistry.</b><br/><br/>This authoritative volume traces the history of chemistry from ancient observations to cutting edge experiments, presenting a total of 250 milestones. From iron smelting to the discovery of the atom, and from fluorescent pigments to sulfa drug synthesis and buckyballs, <i>The Chemistry Book</i> explores both world-changing developments and mind-blowing mysteries.<br/><br/>As the “central science” that bridges biology and physics, chemistry plays an important role in countless medical and technological advances. Covering entertaining stories and unexpected applications, chemist and journalist Derek B. Lowe introduces readers to this endlessly fascinating branch of science.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Derek B Lowe
      </h2>
      
      <p class="authorDescription body article">Since 1989, chemist Derek B. Lowe, has worked for several major pharmaceutical companies on drug discovery projects against schizophrenia, Alzheimer's, diabetes, cancer, and other diseases. After receiving his PhD in chemistry from Duke University, he was awarded a Humboldt fellowship to do postdoctoral research in Germany and has since handled almost 50 elements of the Periodic table. His columns on organic and medicinal chemistry are featured in the Royal Society of Chemistry journal Chemistry World, and he has served on the advisory board for Chemical & Engineering News. Having written daily for the popular “In the Pipeline” blog (pipeline.corante.com) for over 12 years, Lowe is also a science blog pioneer with 6,000-plus Twitter followers. He lives in MA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c923b8c